<a
  href="#{{ containerName }}"
  id="skipnav-{{ containerName }}"
  class="a11y-hide"
  data-dgat="skip-nav-ac2"
  [textContent]="linkText"
  (click)="skipToContainer($event)"
></a>
